import { isNone } from '@ember/utils';
import { computed, observer } from '@ember/object';
import { attr, belongsTo } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
const MAX_CODE_LENGTH = 36;
export default ItemsV3Base.extend({
  promoCode: attr('string', {
    defaultValue: ''
  }),
  numTimesAllowed: attr('number'),
  numTimesUsed: attr('number'),
  startsAt: attr('epoch-date-time'),
  endsAt: attr('epoch-date-time'),
  active: attr('boolean'),
  limitedUse: attr('boolean'),
  discount: belongsTo('discount'),
  usesLeft: computed('numTimesUsed', 'numTimesAllowed', function () {
    return Math.max(0, this.numTimesAllowed - this.numTimesUsed);
  }),
  _normalizePromoCode(code) {
    return String(!isNone(code) ? code : '').trim().toUpperCase();
  },
  // eslint-disable-next-line ember/no-observers
  promoCodeChanged: observer('promoCode', function () {
    this.set('promoCode', this._normalizePromoCode(this.promoCode));
  }),
  startsImmediately: computed('startsAt', {
    get() {
      const now = new Date();
      return this.startsAt === null || this.startsAt.getTime() === now.getTime();
    },
    set(prop, newStartsImmediately) {
      const now = new Date();
      if (newStartsImmediately) {
        this.set('startsAt', now);
      } else {
        this.set('startsAt', new Date(now.getTime() + 1));
      }
      return newStartsImmediately;
    }
  }),
  neverEnding: computed('endsAt', {
    get() {
      return this.endsAt === null;
    },
    set(prop, newNeverEnding) {
      if (newNeverEnding) {
        this.set('endsAt', null);
      } else {
        this.set('endsAt', new Date());
      }
      return newNeverEnding;
    }
  }),
  serialize() {
    this.set('promoCode', this._normalizePromoCode(this.promoCode));
    if (this.startsAt === null) {
      this.set('startsAt', new Date());
    }
    return this._super();
  }
}).reopenClass({
  catalogType() {
    return 'PROMO';
  },
  MAX_CODE_LENGTH,
  createDefaultOptions() {
    return {
      numTimesAllowed: 0,
      numTimesUsed: 0,
      active: false,
      limitedUse: false,
      startsAt: null
    };
  }
});